<!--
 * @Author: wh
 * @Date: 2020-08-14 15:15:40
 * @LastEditTime: 2023-01-18 17:07:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\contractCredit\index.vue
-->
<template>
    <div class="contractCredit">
        <van-nav-bar
            title="合同授信"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <van-calendar
            v-model="showCalendar"
            type="range"
            :min-date="minDate"
            :default-date="defaultDate"
            @confirm="onConfirm"
            color="#3495FB"
        ></van-calendar>
        <div class="search-con">
            <div class="time-con" @click="showCalendar=true">
                <span>合同生效时间：{{ begin_time }} | {{ end_time }}</span>
            </div>
        </div>
        <div class="list">
            <template v-for="(item,index) in list">
                <div class="item" :key="index" :class="'item'+ index">
                    <h4>
                        <span class="iconfont iconhetong"></span>
                        <span v-if="item.contract_type==='102-ZS0'">临供合同</span>
                        <span v-else-if="item.contract_type==='102-LS1'">垫资合同</span>
                        <span v-else-if="item.contract_type==='102-XX0'">预付款合同</span>
                        <span v-else-if="item.contract_type==='102-LS2'">零售合同</span>
                        <span class="unit">(万元)</span>
                    </h4>
                    <div class="column-con">
                        <div class="column-item">
                            <div class="tit">
                                <span class="iconfont iconjine1"></span>
                                <span>累计应收</span>
                            </div>
                            <div class="rectangle vlume-rectangle">
                                {{ item.aggregate_receivables }}
                            </div>
                        </div>
                        <div class="column-item">
                            <div class="tit">
                                <span class="iconfont iconjine1"></span>
                                <span>累计实收</span>
                            </div>
                            <div class="rectangle price-rectangle">
                                {{ item.aggregate_official_receipt }}
                            </div>
                        </div>
                        <div class="column-item">
                            <div class="tit">
                                <span class="iconfont iconjine1"></span>
                                <span>应收余额</span>
                            </div>
                            <div class="rectangle account-rectangle">
                                {{ item.receivable }}
                            </div>
                        </div>
                        <!-- <div class="column-item">
                            <div class="tit">
                                <span class="iconfont iconjine1"></span>
                                <span>实收金额</span>
                            </div>
                            <div class="rectangle received-rectangle">
                                {{ item.aggregate_official_receipt }}
                            </div>
                        </div> -->
                    </div>
                    <table v-if="item.children">
                        <thead>
                            <tr>
                                <th>类型</th>
                                <th>金额</th>
                                <th>耗用</th>
                                <th>剩余</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(v, vIndex) in item.children">
                                <tr
                                    :key="`${item.contract_type}_${vIndex}`"
                                    v-if="v.type!==2"
                                >
                                    <td class="row-tit" v-if="v.type===1">
                                        合同授信
                                    </td>
                                    <!-- <td class="row-tit" v-else-if="v.type===2">
                                        个人担保
                                    </td> -->
                                    <td class="row-tit" v-else-if="v.type===3">
                                        超限发货申请
                                    </td>
                                    <td>{{ v.credit_money }}</td>
                                    <td>{{ v.credit_consume_money }}</td>
                                    <td>{{ v.credit_surplus_money }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="split" :key="`split_${index}`"></div>
                <template>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import util from '@/utils/util';
export default {
    components: {},
    props: {},
    data() {
        return {
            // 展示日历
            showCalendar: false,
            // 开始时间
            begin_time: '',
            // 结束时间
            end_time: '',
            minDate: new Date(1990, 0, 1),
            // eslint-disable-next-line no-irregular-whitespace
            defaultDate: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
            // 合同类型集合
            list: [],
        };
    },
    watch: {
        showCalendar(val) {
            if (val) {
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.height = '100%';
                document.body.style.width = '100%';
            } else {
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.height = '';
                document.body.style.width = '';
            }

        },
    },
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        // 初始化
        init() {
            this.end_time = util.currentTimeFormat('yyyy-MM-dd');
            const date = new Date();
            const year = date.getFullYear();
            this.begin_time = year + '-01-01';
            this.getStatType();
        },
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取合同类型
        async getStatType() {
            const stat = await this.getStatTypeApi();
            if (stat) {
                // 正式赊销合同   102-ZS0
                // 临时赊销合同  102-LS1
                // 现销合同         102-XX0
                // 零售合同         102-LS2
                let res = stat.map(item => {
                    if (item.contract_type === '102-ZS0') {
                        item.sort_num = 0;
                    }
                    if (item.contract_type === '102-LS1') {
                        item.sort_num = 1;
                    }
                    if (item.contract_type === '102-XX0') {
                        item.sort_num = 2;
                    }
                    if (item.contract_type === '102-LS2') {
                        item.sort_num = 3;
                    }
                    if (item.aggregate_receivables) {
                        if (Number(item.aggregate_receivables) !== 0) {
                            item.aggregate_receivables = (Number(item.aggregate_receivables) / 10000).toFixed(2);
                        }
                    }
                    if (item.aggregate_official_receipt ) {
                        if (Number(item.aggregate_official_receipt) !== 0) {
                            item.aggregate_official_receipt = (Number(item.aggregate_official_receipt) / 10000).toFixed(2);
                        }
                    }
                    if (item.receivable ) {
                        if (Number(item.receivable !== 0)) {
                            item.receivable = (Number(item.receivable) / 10000).toFixed(2);
                        }
                    }
                    return item;
                });
                res = res.sort((a, b) => {
                    return a.sort_num - b.sort_num;
                });
                this.list = res;
                const credit = await this.getCreditTypeApi();
                if (credit) {
                    credit.map(item => {
                        if (item.credit_consume_money ) {
                            if (Number(item.credit_consume_money) !== 0) {
                                item.credit_consume_money = (Number(item.credit_consume_money) / 10000).toFixed(2);
                            }
                        }
                        if (item.credit_money ) {
                            if (Number(item.credit_money) !== 0) {
                                item.credit_money = (Number(item.credit_money) / 10000).toFixed(2);
                            }
                        }
                        if (item.credit_surplus_money ) {
                            if (Number(item.credit_surplus_money) !== 0) {
                                item.credit_surplus_money = (Number(item.credit_surplus_money) / 10000).toFixed(2);
                            }
                        }
                    });
                    this.list = this.list.map(item => {
                        credit.map(v => {
                            if (v.contract_type === item.contract_type) {
                                if (item.children) {
                                    item.children.push(v);
                                } else {
                                    item.children = [];
                                    item.children.push(v);
                                }
                            }
                        });
                        return item;
                    });
                    this.list = this.list.map(item => {
                        if (item.children) {
                            item.children = item.children.sort((a, b) => {
                                return a.type - b.type;
                            });
                        }
                        return item;
                    });
                }
            }
        },
        getStatTypeApi() {
            const path = '/interfaceApi/sale/contract_progress/get_stat_type?begin_time='
            + this.begin_time + '&end_time=' + this.end_time;
            return this.$axios.$get(path, { defEx: true });
        },
        getCreditTypeApi() {
            const path = '/interfaceApi/sale/contract_progress/get_credit_type?begin_time='
            + this.begin_time + '&end_time=' + this.end_time;
            return this.$axios.$get(path, { defEx: true });
        },

        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        // 时间选择完成
        onConfirm(date) {
            const [start, end] = date;
            this.showCalendar = false;
            this.begin_time = this.formatDate(start);
            this.end_time = this.formatDate(end);
            this.getStatType();
        },
        doHandleMonth(month) {
            let m = month;
            if (month.toString().length === 1) {
                m = '0' + month;
            }
            return m;
        },
    },
};
</script>
<style lang="stylus">
.contractCredit
    height 100%
    background #F0F0F0
    .search-con
        height 55rpx
        padding 0 20rpx
        background #fff
        padding-top 10rpx
        .time-con
            height 40rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            text-align center
            line-height 40rpx
            font-size 16rpx
    .list
        height calc(100% - 100rpx)
        overflow-y auto
        .item
            padding 10rpx
            background #fff
            .column-con
                display flex
                justify-content space-between
                .column-item
                    flex 1
                    margin-right 5rpx
                    flex-shrink 0
                    width 25%
                    .tit
                        font-size 12rpx
                        color #666666
                        margin-bottom 5rpx
                        .iconfont
                            font-size 12rpx
                            margin-right 2rpx
                    .rectangle
                        text-align center
                        line-height 30rpx
                        height 30rpx
                        background rgba(250,132,54,0.06)
                        border-radius 4rpx
                        border 1px solid rgba(255,216,191,1)
                        overflow hidden
                        white-space nowrap
                        text-overflow ellipsis
                        padding 0 5rpx
                        &.vlume-rectangle
                            background rgba(250,132,54,0.06)
                            border-radius 4rpx
                            border 1px solid rgba(255,216,191,1)
                            color #FA8436
                        &.price-rectangle
                            background rgba(134,107,238,0.06)
                            border-radius 4px
                            border 1px solid rgba(210,198,255,1)
                            color #866BEE
                        &.account-rectangle
                            background rgba(85,136,241,0.06)
                            border-radius 4px
                            border 1px solid rgba(189,210,255,1)
                            color #5588F1
                        &.received-rectangle
                            background rgba(33,189,204,0.06)
                            border-radius 4px
                            border 1px solid rgba(171,224,229,1)
                            color #21BDCC
            h4
                font-size 18rpx
                margin-bottom 10rpx
                .iconfont
                    margin-right 5rpx
                .unit
                    color #999
                    font-size 12rpx
                    margin-left 5rpx
            table
                width 100%
                border-spacing 0px
                border-collapse collapse
                margin-top 10rpx
                table-layout fixed
                th
                    background rgba(235,240,252,1)
                    height 45rpx
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    font-size 14rpx
                    font-weight normal
                td
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    height 45rpx
                    text-align center
                    width 40rpx
                    font-size 14rpx
                    background rgba(85,136,241,.04)
                    width 25%
                    &.row-tit
                        background rgba(235,240,252,1)
        .item0
            h4
                color #E50C0D
        .item1
            h4
                color #191990
        .item2
            h4
                color #00A84B
        .item3
            h4
                color #FF6600
        .split
            height 10rpx
            background #F0F0F0
</style>